export default {
  'gridDatePicker.transactionFor': '<%= name %> for',
  'gridDatePicker.last7days': 'Last 7 Days'
};
